import { GcpPlacementService, ScheduledFlight } from '../../../../types';

export const getNextScheduledFlight = (scheduledFlights?: ScheduledFlight[]) => {
  if (!scheduledFlights) {
    return null;
  }

  const sortedScheduledFlights = scheduledFlights.sort((a, b) =>
    new Date(a.flightDateIso) > new Date(b.flightDateIso) ? 1 : -1,
  );

  return sortedScheduledFlights[0];
};

export const getNextScheduledGcpPlacementService = (gcpPlacementServices?: GcpPlacementService[]) => {
  if (!gcpPlacementServices) {
    return null;
  }

  const sortedGcpPlacementServices = gcpPlacementServices.sort((a, b) =>
    new Date(a.servicesPerformedDateIso) > new Date(b.servicesPerformedDateIso) ? 1 : -1,
  );

  return sortedGcpPlacementServices[0];
};
